import React, { useState } from "react";
import PropTypes from "prop-types";
import useScans from "../../hooks/useScans";
import { incrementUploadRequest, updateScanStatus, signOutUser } from "../../services/scannedDataService";
import ScannedDataView from "./ScannedDataView";

// Batch 5 – MVC refactor of ScannedData (Container)
export default function ScannedDataContainer({
  user,
  viewUserID,
  isAdmin,
  onStartScan,
  onOpenPhotoCapture,
  onOpenAddressEditor,
  onBackToUserSelection,
}) {
  const scans = useScans(user, viewUserID);
  const [selectedData, setSelectedData] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [statusModal, setStatusModal] = useState({ open: false, scan: null, targetStatus: "", note: "" });

  const userPath = viewUserID || user?.email?.replaceAll(".", "-");
  const isViewingOtherUser = isAdmin && viewUserID && viewUserID !== user?.email?.replaceAll(".", "-");

  const handleRequestUpload = async (ev, scan) => {
    ev.stopPropagation();
    if (!userPath) return;
    await incrementUploadRequest(userPath, scan.key);
    onOpenPhotoCapture?.(userPath, scan.key);
  };

  const handleEditAddress = (ev, scan) => {
    ev.stopPropagation();
    if (!userPath) return;
    onOpenAddressEditor?.(userPath, scan.key);
  };

  const handleInitiateStatusUpdate = (ev, scan, newStatus) => {
    ev.stopPropagation();
    setStatusModal({ open: true, scan, targetStatus: newStatus, note: scan.note || "" });
  };

  const handleConfirmStatusUpdate = async () => {
    const { scan, targetStatus, note } = statusModal;
    if (!userPath || !scan) return;
    if ((targetStatus === "disputed" || targetStatus === "rejected") && !note.trim()) {
      alert(`A note is required when marking as ${targetStatus}.`);
      return;
    }
    await updateScanStatus(userPath, scan.key, targetStatus, note);
    setStatusModal({ open: false, scan: null, targetStatus: "", note: "" });
  };

  const handleCancelStatusUpdate = () => setStatusModal({ open: false, scan: null, targetStatus: "", note: "" });

  const handleSignOut = async () => {
    await signOutUser();
  };

  const getScanStatus = (scan) => {
    if (scan.status) return scan.status;
    return "pending";
  };

  return (
    <ScannedDataView
      scans={scans}
      selectedData={selectedData}
      setSelectedData={setSelectedData}
      filterStatus={filterStatus}
      setFilterStatus={setFilterStatus}
      statusModal={statusModal}
      setStatusModal={setStatusModal}
      user={user}
      viewUserID={viewUserID}
      isAdmin={isAdmin}
      onStartScan={onStartScan}
      onOpenPhotoCapture={onOpenPhotoCapture}
      onOpenAddressEditor={onOpenAddressEditor}
      onBackToUserSelection={onBackToUserSelection}
      userPath={userPath}
      isViewingOtherUser={isViewingOtherUser}
      handleRequestUpload={handleRequestUpload}
      handleEditAddress={handleEditAddress}
      handleInitiateStatusUpdate={handleInitiateStatusUpdate}
      handleConfirmStatusUpdate={handleConfirmStatusUpdate}
      handleCancelStatusUpdate={handleCancelStatusUpdate}
      handleSignOut={handleSignOut}
      getScanStatus={getScanStatus}
    />
  );
}

ScannedDataContainer.propTypes = {
  user: PropTypes.object,
  viewUserID: PropTypes.string,
  isAdmin: PropTypes.bool,
  onStartScan: PropTypes.func,
  onOpenPhotoCapture: PropTypes.func,
  onOpenAddressEditor: PropTypes.func,
  onBackToUserSelection: PropTypes.func,
};
